exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle {\n  display: block; }\n\n.header {\n  margin-bottom: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/renamable/rename-modal/rename-modal.component.scss
// module id = ../../../../../src/app/renamable/rename-modal/rename-modal.component.scss
// module chunks = main